import { useAtom } from 'jotai';
import Image from 'next/legacy/image';
import { useState } from 'react';

import download from '/public/images/graduate/download.svg';
import { useApplicantId } from '@/hooks/react-query/v2/graduate';
import { divToPdf } from '@/lib/utils/businessLogics/graduate';
import { getUserInfoFromClientCookie } from '@/lib/utils/cookie';
import { graduateDownloadModalAtom } from '@/store/v2/graduate';

import * as S from './style';

export default function Certificate({
  graduateName,
  certificate,
  applicantId,
  round,
}: {
  graduateName: string;
  certificate: {
    name: string;
    startDate: string;
    endDate: string;
  };
  applicantId: string;
  round: string;
}) {
  const startDate = certificate.startDate.split('T')[0];
  const endDate = certificate.endDate.split('T')[0];
  const { data } = useApplicantId(round);
  const [, setModal] = useAtom(graduateDownloadModalAtom);
  const [isDownloading, setIsDownloading] = useState(false);
  const { _id: onlineUserId } = getUserInfoFromClientCookie();

  const saveCertificate = () => {
    if (onlineUserId === '') {
      setModal(true);
      return;
    }
    if (applicantId !== data) {
      alert('수료생 본인만 저장할 수 있어요!');
      return;
    }
    setIsDownloading(true);
    const div = document.getElementById('certificate');
    divToPdf(div, certificate.name);
    setTimeout(() => setIsDownloading(false), 1000);
  };

  return (
    <>
      <S.Wrapper>
        <S.Title>{graduateName}님의 수료증 👏</S.Title>
        <S.Certificate>
          <Image
            src={`${process.env.NEXT_PUBLIC_CDN_BASE_URL}/hanghae99/certificate_jpg.jpg`}
            alt='certificate'
            layout='fill'
            objectFit='contain'
          />
          <S.CertificateText>
            <S.Name>{graduateName}</S.Name>
            <S.Desc>
              위 사람은 교육기관 팀스파르타(주)가 <br />
              주관한 항해99 {certificate.name} 과정({startDate}~{endDate})을
              <br />
              성공적으로 수료하였으므로 이 증서를 수여합니다.
            </S.Desc>
          </S.CertificateText>
          <S.GraduateDate>{endDate}</S.GraduateDate>
        </S.Certificate>
        <S.SaveButton onClick={saveCertificate} disabled={isDownloading}>
          수료증 저장하기
          <S.DownloadImg>
            <Image src={download} layout='fill' objectFit='contain' />
          </S.DownloadImg>
        </S.SaveButton>
      </S.Wrapper>
    </>
  );
}
